import React, { useContext as useContextCore } from 'react'
import { useParams } from 'react-router-dom'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const Provider = ({ children, ...props }) => {
  const { _id } = useParams()

  return <CoreProvider value={{ ...props, orderId: _id }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
